// extracted by mini-css-extract-plugin
module.exports = {"canvas":"StreamCoverImage_canvas__EebqW"};